import axios from 'axios';
import {
    errorResponse,
    validateApiData
} from '../../utils/validators/validators';
import { SERVER_URL } from '../../utils/config/constants';
import { getCookies, cookies } from '../../utils/getToken';
import { store } from '../../store/index';

export const categoryList = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/category/list`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const topCategory = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: { limit: 4 },
            url: `${SERVER_URL}/category/top`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerSearchList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider/search`,
            headers: {
                'x-auth-token': authToken
                // latitude: store.getState().settings.currentLocation.latitude,
                // longitude: store.getState().settings.currentLocation.longitude
            }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerMainSearchList = async params => {
    var authToken = getCookies();
    var latitude = cookies.get('latitude', { path: '/' });
    var longitude = cookies.get('longitude', { path: '/' });
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider/search-main`,
            headers: {
                'x-auth-token': authToken,
                latitude: latitude,
                longitude: longitude
            }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerCategoryList = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/profile/my-categories`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const mainSearch = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/user/search?text=${params.keyword}&type=${params.type}`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const serviceList = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/service/list`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const allServices = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/category/allservices`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerServiceList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: params,
            url: `${SERVER_URL}/provider-service/get`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const getProviderServices = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: params,
            url: `${SERVER_URL}/provider-service/getmine`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const serviceChangeStatus = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/status`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const getCategoryService = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/category/services`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const addService = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/create`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const updateProviderService = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/update`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerServiceDetail = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: params,
            url: `${SERVER_URL}/provider-service/detail`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const addServiceFaq = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/faq/create`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const addServicePackage = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/package/create`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const updateServiceFaq = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/faq/update`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const updateServicePackage = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/package/update`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const serviceFaqDetail = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/faq/detail`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const servicePackageDetail = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/package/detail`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const deleteServiceFaq = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/faq/delete`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const deleteServicePackage = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/package/delete`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const addServiceGalleryImage = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/create-media`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const providerServiceVideoList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-url/list`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const addVideoUrl = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-url/create`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const updateVideoUrl = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-url/update`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const deleteServiceVideoUrl = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-url/delete`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const providerServiceVideoDetail = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-url/detail`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const topServiceList = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/service/top`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};



// WEBPACK FOOTER //
// ./src/apiHelpers/category/list.js